import { useCallback, useRef } from 'react';
import useMount from '@picsart/rc/useMount';

const useNetworkConnection = () => {
  const favicon = useRef<string | undefined>();
  useMount(() => {
    const icons = Array.from(document.querySelectorAll('link[sizes="16x16"]'));
    favicon.current = (icons as HTMLLinkElement[]).filter(x => x.href)[0]?.href;
  });

  return useCallback(() => new Promise(resolve => {
    if (favicon.current) {
      fetch(favicon.current).then(() => resolve(true)).catch(() => resolve(false));
    } else {
      resolve(navigator.onLine);
    }
  }), []);
};

export default useNetworkConnection;
